import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const DetailsEventExpandButton = ({ expandedMarketTypes, marketTypes, setExpandedMarketTypes }) => {
  const marketTypesIds = useMemo(
    () => Object.values(marketTypes)?.map(({ id }) => `${id}`),
    [marketTypes],
  );

  const collapsedMarketTypeIds = useMemo(
    () =>
      Object.entries(expandedMarketTypes)
        ?.map(([key, value]) => !value && key)
        .filter(Boolean),
    [expandedMarketTypes],
  );

  const isAllMarketsCollapsed = marketTypesIds.length === collapsedMarketTypeIds.length;

  const toggleAllMarketTypesExpand = () => {
    if (isAllMarketsCollapsed) {
      const newExpandedMarketTypes = marketTypesIds.reduce(
        (result, id) => ({ ...result, [id]: true }),
        {},
      );
      setExpandedMarketTypes(newExpandedMarketTypes);
    } else {
      const newExpandedMarketTypes = marketTypesIds.reduce(
        (result, id) => ({ ...result, [id]: false }),
        {},
      );
      setExpandedMarketTypes(newExpandedMarketTypes);
    }
  };

  const iconClassName = cx(isAllMarketsCollapsed && 'show', !isAllMarketsCollapsed && 'hide');

  return (
    <div className="collapse-button-container" onClick={toggleAllMarketTypesExpand}>
      <div className="icon-container">
        <Icon className={iconClassName} name={iconClassName} />
      </div>
    </div>
  );
};

DetailsEventExpandButton.propTypes = {
  expandedMarketTypes: PropTypes.objectOf(PropTypes.bool),
  marketTypes: PropTypes.object.isRequired,
  setExpandedMarketTypes: PropTypes.func.isRequired,
};

export default DetailsEventExpandButton;
